import axios from 'axios';

// Créer une instance axios avec la configuration de base
const axiosPeelo = axios.create({
  baseURL: 'https://api.peelo.chat',
  timeout: 15000,
  headers: {
    'Content-Type': 'application/json'
  }
});

// Intercepteur pour ajouter le token d'authentification
axiosPeelo.interceptors.request.use(
  (config) => {
    const userData = localStorage.getItem('user');
    if (userData) {
      const userObj = JSON.parse(userData);
      const token = userObj.data.token;
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Intercepteur pour gérer les réponses
axiosPeelo.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response?.status === 401) {
      // Token expiré ou invalide
      localStorage.removeItem('user');
      // Rediriger vers la page de connexion si nécessaire
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export { axiosPeelo }; 